<template>
    <div class="uk-position-relative">

        <a class="uk-icon-link uk-link-text"
           href="/cart"
           uk-toggle="target: #cart"
           onclick="return false">
            <span uk-icon="icon: cart; ratio: 1.7"></span>
            <span class="uk-badge uk-margin-xsmall-left">{{ Object.keys(data.ShopOrderItems).length }}</span>
        </a>

        <!-- Cart Sidebar -->
        <div id="cart"
             uk-offcanvas="overlay: true; flip: true">
            <aside class="uk-offcanvas-bar uk-padding-remove">

                <div class="uk-card uk-card-small uk-flex uk-flex-column uk-height-1-1">

                    <header class="uk-card-header">
                        <h3 class="uk-card-title uk-margin-remove">Корзина</h3>
                        <button class="uk-offcanvas-close" type="button" style="top: 13px;" uk-close="ratio: 1.7;"></button>
                    </header>

                    <hr class="uk-margin-remove-top">

                    <div class="uk-card-body uk-card-small uk-overflow-auto uk-padding-remove-vertical">
                        <ul class="uk-list uk-list-divider tm-cart-sidebar-list">

                            <cart-navbar-item v-for="Product in data.ShopItems"
                                              :key="Product.ShopItem.id"
                                              :product="Product"
                                              :shop-item-prices="data.ShopItemPrices[Product.ShopItem.id]"
                                              :shop-item-warehouses="data.ShopItemWarehouses[Product.ShopItem.id]"
                                              :shop-order-item.sync="data.ShopOrderItems[Product.ShopItem.id]"
                                              @remove-from-cart="removeFromCart(Product)"

                            >

                            </cart-navbar-item>
                        </ul>
                    </div>

                    <hr class="uk-margin-remove-bottom">

                    <footer class="uk-card-footer">
                        <div class="uk-text-lead uk-text-right">
                            <span class="uk-text-muted">Сумма:</span>
                            <b>{{ cartAmount }} руб.</b>
                        </div>
                        <a class="uk-button uk-button-primary uk-button-primary-navbar-cart uk-width-1-1 uk-margin-small-top" href="/cart">В
                            корзину</a>
                    </footer>

                </div>

            </aside>
        </div>

    </div>
</template>
<script>

    import CartNavbarItem from "./CartNavbarItem";

    export default {
        name: 'CartNavbar',
        components: {CartNavbarItem},
        props: {
            CartItems: {
                type: [Array, Object],
                default() {
                    return []
                }
            }
        },
        data() {
            return {
                data: {
                    cart: {},
                    ShopOrderItems: {}
                }
            }
        },
        created() {
            this.fetchCartData();
            // update data after user actions: put new item to cart, update quantity, remove from cart;
            this.$bus.$on('update-navbar-cart', () => {
                this.fetchCartData();
            });
        },
        computed: {
            cartAmount() {
                return this.data.cart.amount;
            }
        },
        methods: {
            fetchCartData() {
                this.$http.get('/cart').then(response => {

                    this.data = response.body.data;

                }, response => {
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// CartNavbar.vue?7b129c53